import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  publishContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: theme.spacer * 1,
  },
}));

export default useStyles;
